var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusSpooled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49163 0.666656C3.89163 0.666656 0.166626 4.39999 0.166626 8.99999C0.166626 13.6 3.89163 17.3333 8.49163 17.3333C13.1 17.3333 16.8333 13.6 16.8333 8.99999C16.8333 4.39999 13.1 0.666656 8.49163 0.666656ZM8.49996 15.6667C4.81663 15.6667 1.83329 12.6833 1.83329 8.99999C1.83329 5.31666 4.81663 2.33332 8.49996 2.33332C12.1833 2.33332 15.1666 5.31666 15.1666 8.99999C15.1666 12.6833 12.1833 15.6667 8.49996 15.6667ZM8.91663 4.83332H7.66663V9.83332L12.0416 12.4583L12.6666 11.4333L8.91663 9.20832V4.83332Z",
    fill: "#7D7D7D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusSpooled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_status_spooled.faccc3033531c3c0f2444cc5ba11edc5.svg";